import { useState } from "react"
import { cn } from "../lib/utils"
import Button from "./Button"
import { toUppercaseFirstLetter } from "../helpers"

export const Resource = ({ title, description, type, url, attachments }) => {
  const [selectedIndex, setSelectedIndex] = useState(0)

  const singleAttachment = attachments && attachments.length === 1
  const attachmentType = attachments && attachments[0]?.label

  const getButtonText = () => {
    if (type === "video") return "Watch"
    if (type === "link") return "Go Now"
    if (type === "attachment") return "Download"
    return "Download"
  }

  const getPillColor = () => {
    if (type === "video") return "border-gifts text-gifts"
    if (type === "attachment") return "border-vision text-vision"
    if (type === "link") return "border-brand text-brand"
    return "border-gray-200 text-gray-500"
  }

  const getTypeLabel = () => {
    if (type === "video" || type === "link") return type
    if (type === "attachment") return singleAttachment ? attachmentType : ("File" ?? "File")
    return "Other"
  }

  const TypePill = () => (
    <span
      className={cn("rounded-full border bg-white px-4 py-2 text-sm font-bold", getPillColor())}
    >
      {toUppercaseFirstLetter(getTypeLabel())}
    </span>
  )

  const hasContent = url || (attachments && attachments.length > 0)

  const AttachmentDownload = () => {
    const selected = attachments[selectedIndex]
    return (
      <div className="flex flex-row items-center justify-end gap-2 w-full">
        {attachments.length > 1 && (
          <select
            value={selectedIndex}
            onChange={e => setSelectedIndex(Number(e.target.value))}
            className="block rounded-lg border-gray-300 text-sm shadow-sm focus:border-brandSecondary focus:ring-brandSecondary"
          >
            {attachments.map((a, i) => (
              <option key={a.id} value={i}>
                {a.label}
              </option>
            ))}
          </select>
        )}
        <div className="flex-grow"></div>

        <a href={selected.url} target="_blank" rel="noreferrer">
          <Button variant="secondary" padding="px-4 py-2" className="rounded-md" type="button">
            {getButtonText()}
          </Button>
        </a>
      </div>
    )
  }

  return (
    <div className="m-2 flex flex-col gap-4 rounded-lg border border-neutral-200 bg-white p-8">
      <h3 className="text-xl font-bold">{title}</h3>
      <p className="">{description}</p>
      <div className="flex-grow"></div>
      <div className="flex flex-row items-center justify-between gap-2">
        {singleAttachment ? <TypePill /> : null}
        <div className="flex flex-row items-center gap-2 w-full">
          {!hasContent && <div className="flex-grow font-bold text-brand">Coming Soon!</div>}
          {url && (
            <a href={url} target="_blank" rel="noreferrer">
              <Button variant="secondary" padding="px-4 py-2" className="rounded-md" type="button">
                {getButtonText()}
              </Button>
            </a>
          )}
          {attachments && attachments.length > 0 && <AttachmentDownload />}
        </div>
      </div>
    </div>
  )
}
